import { render, staticRenderFns } from "./listarProfesiograma.vue?vue&type=template&id=cd2a6ba4"
import script from "./listarProfesiograma.vue?vue&type=script&lang=js"
export * from "./listarProfesiograma.vue?vue&type=script&lang=js"
import style0 from "./listarProfesiograma.vue?vue&type=style&index=0&id=cd2a6ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports